<template>
  <div v-if="!loading" class="h-full">
    <notification-container></notification-container>
    <Toaster
      class="toaster-mono"
      position="top-center"
      :duration="3000"
      :theme="toasterTheme"
    />
    <transition name="app-fade" mode="out-in">
      <privatetLayout v-if="isLoggedIn" key="private" />
      <publicLayout v-else key="public" />
    </transition>
  </div>
</template>

<script>
import privatetLayout from "@/layout/private";
import publicLayout from "@/layout/public";
import notificationContainer from "@/components/notification/notification-container.vue";
import { Toaster } from "vue-sonner";
import { isDark } from "@/services/theme";
import { whoami } from "@/api/auth";
export default {
  components: {
    privatetLayout,
    publicLayout,
    notificationContainer,
    Toaster,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
    toasterTheme() {
      return isDark() ? "dark" : "light";
    },
  },
  async mounted() {
    const user = await whoami();
    this.loading = false;
    this.$store.commit("user/setUser", user);
  },
};
</script>

<style>
/* Smooth fade-up when the app shell (or login) mounts / switches */
.app-fade-enter-active {
  transition: opacity 0.45s cubic-bezier(0.22, 1, 0.36, 1),
    transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}
.app-fade-leave-active {
  transition: opacity 0.2s ease;
}
.app-fade-enter-from {
  opacity: 0;
  transform: translateY(8px);
}
.app-fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .app-fade-enter-active,
  .app-fade-leave-active {
    transition: none;
  }
}
</style>
